import React from 'react';
import * as Styled from './styled';
import { InputAddonProps } from './types';

const InputAddon: React.FC<InputAddonProps> = ({ children, ...props }) => (
    <Styled.Addon {...props}>{children}</Styled.Addon>
);

export { InputAddon };
